






























import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
  components: {
    SmText: () => import('@/components/atoms/SmText.vue')
  }
})
export default class SmBtnContained extends Vue {
  @Prop()
  private readonly icon?: string

  @Prop()
  private readonly text?: string

  @Prop()
  private readonly count?: number

  @Prop({ default: false })
  private readonly disabled!: boolean

  @Prop()
  private readonly maxWidth?: string
}
